/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { EarlyPayoutRequestResult } from 'legacy/events/types';
import EarlyPayoutsErrorModal from './EarlyPayoutsErrorModal';
import GetVerifiedModal from 'components/Modals/GetVerifiedModal';

const DashboardEarlyPayoutsModal = ({
  open,
  onClose,
  result,
  isError
}: {
  open: boolean;
  onClose?: () => void;
  result: EarlyPayoutRequestResult | undefined;
  isError: boolean;
}) => (
  <>
    {isError ? (
      <EarlyPayoutsErrorModal open={open} onClose={onClose} result={result} />
    ) : (
      <GetVerifiedModal open={open} onClose={onClose} />
    )}
  </>
);

export default DashboardEarlyPayoutsModal;
